export const Access = {
  "user-management": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Client Supervisor"],
  "client-configuration": ["Administrator", "Admin"],
  "bucket-mapping": ["Administrator", "Admin", "Supervisor"],
  "payer-mapping": ["Administrator", "Admin", "Supervisor"],
  "global-insurance": ["Administrator", "Admin"],
  "global-mapping": ["Administrator", "Admin"],
  "dashboard": ["All"],
  "welcome-page": ["Client Supervisor"],
  "change-password": ["All"],
  "auto-allocation": ["Administrator", "Admin"],
  "client-instruction": ["Supervisor", "QC", "Client Supervisor"],
  "data-upload": ["Administrator", "Admin", "Supervisor"],
  "simple-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"],
  "mis-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"],
  "tms-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"],
  "de-allocation": ["Supervisor"],
  "upload-file": ["Supervisor"],
  "view-file": ["Agent"],
  "agent": ["Agent"],
  "supervisor-agent": ["Supervisor"],
  "denial-code": ["Supervisor"],
  "supervisor-dashboard": ["Supervisor"],
  "standard-comment": ["Administrator", "Admin"],
  "client-assistance": ["QC", "Supervisor"],
  "client-approval": ["Client Supervisor"],
  "agent-correspondence": ["Agent"],
  "exception-entry": ["Client Supervisor"],
  "client-instruction-report": ["Client Supervisor"],
  "client-dashboard-report": ["Client Supervisor"],
  "client-user": ["Client User"],
  "tl-deny-report": ['Supervisor'],
  "ageing-dashboard-report": ["Supervisor", "Client Supervisor"],
  "bi-report": ["Supervisor", "Client Supervisor", "Client User", "Director", "Manager"],
  // "kyi-report": ["Supervisor"],
  // "flash-dashboard": ["Supervisor"],
  // "payment-report": ["Supervisor"]
  "bcbs-data-upload": ["Supervisor"],
  "unworked-accounts-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller", "Director", "Manager"],
  "production-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller", "Director", "Manager"],
  "citra-audit": ["Supervisor"],
  "citra-audit-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller", "Director", "Manager"],
  "citra-employee-mapping": ["Administrator", "Admin"],
  "agent-deallocation": "Supervisor",
  "productivity-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Client Supervisor"],
  "agent-productivity-report": ["Agent"],
  "client-user-mapping-management": ["Controller"],
  "user-menu-mapping": ["Administrator", "Admin"],
  /* concluder menus*/
  // "concluder-report": ["Supervisor", "Agent", "Admin"],
  // "deallocate-concluder": ["Supervisor", "Admin"],
  // "upload-mini-insurance": ["Supervisor", "Agent", "Admin"],
  "concluder-dashboard": ["Supervisor", "Director", "Manager"],
  "pcn-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"],
  "concluder-report": ["Supervisor", "Admin", "Director", "Manager"],
  "concluder-deallocation": ["Supervisor"],
  "deallocate-module": ["Admin", "Supervisor"],
  "project-and-priority-report": ["Supervisor", "Admin", "Director", "Manager"],
  "project-and-priority-dashboard": ["Supervisor", "Admin", "Director", "Manager"],
  "client-simple-report": ["Client Supervisor"],
  "supervisor-inbox-mapping": ["Supervisor", "Admin"],
  "agent-inbox-mapping": ["Agent", "Manager", "Supervisor"],
  "concluder-master-update": ["Manager"],
  "agent-reallocation": "Supervisor",
  "carc-rarc-master": ["Admin"],
  "client-account-history": ["Client Supervisor"],
  "ciinra-audit": ["Supervisor"],
  "ciinra-audit-report": ["Supervisor", "Admin"],
  "agent-eob-rff": ["Agent"],
  "RFFIndexing-report": ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"],
  "ScenarioConfiguration": ["Administrator", "Admin","Manager", "Controller"],
  "allocation-dashboard": ["Supervisor", "Director", "Manager", "Admin"],
  "unallocation-dashboard": ["Supervisor", "Director", "Manager", "Admin"],
  "rff-allocation" :["Supervisor"],
  "rule-configuration": ["Controller", "Admin"],
  "ClaimAssist-Upload": ["Administrator", "Admin", "Manager"],
  // "agent-cbf-nr": ["Agent"],
  // "agent-cbf-calling": ["Agent"],
  "cbf-report": ["Supervisor", "Admin", "Director", "Manager"],
    "contact-support": ["Agent","Administrator", "Admin", "Supervisor", "Manager", "Controller"],

};
  //add new role here agent-eob-rff
